import React, { useState } from "react";
import NewInvoice from "./components/Invoice/NewInvoice";
import OldInvoice from "./components/Invoice/OldInvoice";

const Invoice = ({ authrztn }) => {
  const [selectedValue, setSelectedValue] = useState("NEW");
  return (
    <>
      {selectedValue === "NEW" ? (
        <NewInvoice authrztn={authrztn} />
      ) : (
        <OldInvoice authrztn={authrztn} />
      )}
    </>
  );
};

export default Invoice;
